import { render, staticRenderFns } from "./chevron-down.vue?vue&type=template&id=36ba91b4"
import script from "./chevron-down.vue?vue&type=script&lang=js"
export * from "./chevron-down.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports